/**
 * AI.GEN lines=1-10
 * 钉钉登录服务 - 参考旧调度项目实现
 */
import { EnvironmentName, getSSODomain } from '@hpfe/common-base';
import Cookies from 'js-cookie';

import { domainEnum, tokenNameEnum } from '@/components/enum';
import { context } from '@/context';

export default class DingTalkLogin {
  /** 延迟获取 config，避免循环依赖 */
  private static get config() {
    return context.config;
  }

  private static get tokenName() {
    const { environmentName, countryCode } = this.config;
    return environmentName === EnvironmentName.release
      ? tokenNameEnum[countryCode.toUpperCase()]
      : 'CN_token';
  }

  private static get domain() {
    return domainEnum[this.config.environmentName];
  }

  static getToken() {
    return Cookies.get(this.tokenName) || Cookies.get('token');
  }

  static setToken(value: string) {
    Cookies.set(this.tokenName, value, { domain: this.domain, path: '/' });
    Cookies.set('token', value, { domain: this.domain, path: '/' });
  }

  static removeToken() {
    Cookies.remove(this.tokenName, { domain: this.domain, path: '/' });
    Cookies.remove('token', { domain: this.domain, path: '/' });

    Object.values(domainEnum).forEach((item: string) => {
      Cookies.remove(this.tokenName, { domain: item, path: '/' });
      Cookies.remove('token', { domain: item, path: '/' });
    });
  }

  /**
   * 跳转到登录页面
   */
  static jumpToLogin() {
    const origin = getSSODomain(this.config.environmentName);
    const loginUrl = `${origin}?sourceSiteUrl=${window.location.origin}&sourceId=3`;
    window.location.replace(loginUrl);
  }

  static init() {
    const token = Cookies.get(this.tokenName) || Cookies.get('token');

    if (token) {
      Cookies.set('token', token, { domain: this.domain, path: '/' });
    } else {
      this.removeToken();
      this.jumpToLogin();
    }
  }
}
